module.exports = __webpack_public_path__ + "static/media/thumbnail1.7c7ce63e.png";